import { render } from "./BlogComment.vue?vue&type=template&id=45d8b2d6&scoped=true"
import script from "./BlogComment.vue?vue&type=script&lang=js"
export * from "./BlogComment.vue?vue&type=script&lang=js"

import "./BlogComment.vue?vue&type=style&index=0&id=45d8b2d6&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d8b2d6"]])

export default __exports__